import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, TextField,
} from '@mui/material';

interface DocumentVerifyConfirmDialogProps {
  open: boolean;
  type: 'approve' | 'deny' | null;
  documentName?: string;
  reason: string;
  onReasonChange: (v: string) => void;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DocumentVerifyConfirmDialog({
  open, type, documentName, reason, onReasonChange, loading, onClose, onConfirm,
}: DocumentVerifyConfirmDialogProps) {
  const isDeny = type === 'deny';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        {isDeny ? 'Deny document' : 'Approve document'}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={2}>
          {documentName ? (
            <>Confirm {isDeny ? 'denial' : 'approval'} for <strong>{documentName}</strong>.</>
          ) : (
            <>Confirm this document {isDeny ? 'denial' : 'approval'}.</>
          )}
        </Typography>
        {isDeny && (
          <TextField
            autoFocus
            fullWidth
            multiline
            rows={2}
            required
            label="Rejection reason"
            value={reason}
            onChange={(e) => onReasonChange(e.target.value)}
            placeholder="Reason shown to the partner"
            helperText="The partner is notified with this reason and can re-upload; the new copy returns to this queue."
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button
          variant="contained"
          color={isDeny ? 'error' : 'success'}
          onClick={onConfirm}
          disabled={loading || (isDeny && !reason.trim())}
        >
          {isDeny ? 'Deny' : 'Approve'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
